import React, { useEffect, useRef, useState } from "react";
import {
  PDFViewer,
  Document,
  Text,
  View,
  Image,
  Page,
  Link,
  StyleSheet,
  Font,
  pdf,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import Poppins from "./../Assets/Fonts/Poppins/Poppins-Regular.ttf";
import Poppins_Bold from "./../Assets/Fonts/Poppins/Poppins-Bold.ttf";
import Poppins_Lite from "./../Assets/Fonts/Poppins/Poppins-Light.ttf";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateString, split_number } from "../Common/CommonFunction";
import { ToastContainer } from "react-toastify";
import { ArrowLeft } from "react-feather";

export const QuotationPDF = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const [toolvalues, setToolvalues] = useState([
    {
      quantity: 10,
      price: 100,
      total_value: 1000,
      discount: 10,
      discounted_value: 900,
      currency: "INR",
    },
    {
      quantity: 15,
      price: 100,
      total_value: 1500,
      discount: 15,
      discounted_value: 1275,
      currency: "INR",
    },
    {
      quantity: 20,
      price: 100,
      total_value: 2000,
      discount: 20,
      discounted_value: 1600,
      currency: "INR",
    },
    {
      quantity: 25,
      price: 100,
      total_value: 2500,
      discount: 25,
      discounted_value: 1875,
      currency: "INR",
    },
    {
      quantity: 30,
      price: 100,
      total_value: 3000,
      discount: 30,
      discounted_value: 2100,
      currency: "INR",
    },
  ]);
  const [pdfBlobUrl, setPdfBlobUrl] = useState("");
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const downloadLinkRef = useRef(null);
  const data = location.state;
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  console.log("data", data);
  Font.register({
    family: "poppins, poppins-light,poppins-bold",
    fonts: [
      {
        src: Poppins,
      },
      {
        src: Poppins_Bold,
        fontWeight: 600,
      },
    ],
  });

  const styles = StyleSheet.create({
    viewer: {
      width: "100%",
      height: window.innerHeight,
    },
    page: {
      paddingTop: 15,
      paddingBottom: 40,
      paddingHorizontal: 15,
      color: "black",
      fontFamily: "poppins, poppins-light,poppins-bold",
    },
    borderedView: {
      border: "1px solid black",
      padding: 10,
      flexGrow: 1,
      margin: 5,
    },
    pageNumber: {
      position: "absolute",
      fontSize: 12,
      bottom: 28,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "black",
    },
    footer: {
      position: "absolute",
      fontSize: 12,
      bottom: 0,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "black",
      paddingTop: "50px",
      paddingBottom: "10",
      paddingLeft: "15",
      paddingRight: "15",
      // borderTop:'1px solid black',
    },
    title: {
      textAlign: "center",
    },
    header: {
      margin: 5,
      color: "black",
      fontSize: "10px",
    },
    headerrow: {
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: 5,
      alignItems: "justify-content-between",
      width: "100%",
      gap: "5%",
      // border: "1px solid black",
    },
    headerbox: {
      margin: 5,
      color: "black",
      fontSize: "10px",
      width: "50%",
    },
    headerrow2: {
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: 5,
      alignItems: "justify-content-between",
      width: "100%",
      gap: "5%",
      backgroundColor: "#BCF2F6",
      // border: "1px solid black",
    },
    headerbox2: {
      margin: 5,
      color: "black",
      fontSize: "12px",
      width: "50%",
      // border: "1px solid black",
    },
    headerrow3: {
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: 5,
      alignItems: "justify-content-between",
      width: "100%",
      gap: "5%",
    },
    headerbox3: {
      margin: 5,
      color: "black",
      fontSize: "12px",
      width: "50%",
      // border:"1px soild black"
    },
    headerrow4: {
      flexDirection: "row",
      marginBottom: 10,
      padding: "5px",
      width: "100%",
      fontSize: "12px",
      backgroundColor: "#f5f5f5",
    },
    headerbox4: {
      margin: 5,
      color: "black",
      fontSize: "12px",
      width: "50%",
      // border: "1px solid black",
    },
    row: {
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: 5,
    },
    label: {
      fontSize: "10px",
      fontWeight: "bold",
    },
    value: {
      flex: 1,
      fontSize: "10px",
      marginLeft: "5px",
    },
    tableheader: {
      flexDirection: "row",
      marginBottom: 5,
      width: "100%",
      fontSize: "10px",
      gap: "2%",
      backgroundColor: "#f5f5f5",
    },
    tablecolumn1: {
      width: "10%",
    },
    tablecolumn2: {
      width: "35%",
    },
    tablecolumn3: {
      width: "15%",
    },
    tablecolumn4: {
      width: "15%",
      textAlign: "center",
    },
    tablerows: {
      flexDirection: "row",
      marginBottom: 5,
      width: "100%",
      fontSize: "10px",
      gap: "2%",
    },
    pricetableheader: {
      flexDirection: "row",
      marginTop: 10,
      marginBottom: 5,
      width: "100%",
      fontSize: "10px",
      backgroundColor: "#f5f5f5",
    },
    tablecolumn5: {
      width: "15%",
    },
    pricetablerows: {
      flexDirection: "row",
      marginBottom: 5,
      width: "100%",
      fontSize: "10px",
    },
    tool_img: {
      flexDirection: "row",
      alignItems: "center",
      fontSize: "10px",
      width: "100%",
      // border: "1px solid black",
      // backgroundColor: "grey",
    },
    image: {
      width: "80%",
      height: "250px",
      // margin: "2%",
    },
    paymentBox: {
      width: "100%", // Adjust width as needed
      padding: 10,
      // border: "1px solid black",
      borderRadius: 5,
      marginTop: 20,
      display: "flex",
      flexDirection: "row-reverse",
    },
    main_row:{
      // display: "flex",
      // flexDirection: "row-reverse",
      // border: "1px solid black",
      width:"50%"
    },
    payment_row: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 5,
    },
    payment_label: {
      fontSize: 12,
      fontWeight: "bold",
    },
    payment_value: {
      fontSize: 12,
    },
  });

  useEffect(() => {
    const generatePdfBlob = async () => {
      const doc = <SupplierQuotationPDF data={data} />;
      const asPdf = pdf([]);
      asPdf.updateContainer(doc);
      const blob = await asPdf.toBlob();
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      setIsPdfLoaded(true);
    };

    generatePdfBlob();
  }, [data]);

  const handleDownload = () => {
    const link = downloadLinkRef.current;
    link.href = pdfBlobUrl;
    link.download = `Quotation - ${data.quotation_id}.pdf`;
    link.click();
  };

  const SupplierQuotationPDF = ({ data }) => (
    <Document title={`Quotation - ${data.quotation_id}`}>
      <Page size="A4" style={styles.page}>
        <View>
          <Text style={styles.title}>Quotation</Text>
          <View style={styles.header}>
            {/* Quotation Number */}
            <Text>Quotation No: {data.quotation_id}</Text>
          </View>
          {/* Quotation date & Due date  */}
          <View style={styles.headerrow}>
            <View style={styles.headerbox}>
              <Text>
                Quotation Date: {formatDateString(data.quotation_date, "-")}
              </Text>
            </View>
            <View style={styles.headerbox}>
              <Text>
                Valid Till Date: {formatDateString(data.quotation_date, "-")}
              </Text>
            </View>
          </View>
          {/* Quotation to & from header */}
          <View style={styles.headerrow2}>
            <View style={styles.headerbox2}>
              <Text>Quotation From:</Text>
            </View>
            <View style={styles.headerbox2}>
              <Text>Quotation To:</Text>
            </View>
          </View>

          {/* Quotation to & from infomation  */}
          <View style={styles.headerrow3}>
            <View style={styles.headerbox3}>
              <View style={styles.row}>
                <Text style={styles.label}>Business Name:</Text>
                <Text style={styles.value}>{user_details.company_name}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Address:</Text>
                <Text style={styles.value}>{user_details.location}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>GST No:</Text>
                <Text style={styles.value}>{user_details.gst_number}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Email:</Text>
                <Text style={styles.value}>
                  {user_details?.email ? user_details.email : "NA"}
                </Text>
              </View>
            </View>

            <View style={styles.headerbox3}>
              <View style={styles.row}>
                <Text style={styles.label}>Business Name:</Text>
                <Text style={styles.value}>{data.customer}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Address:</Text>
                <Text style={styles.value}>{data.address}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>GST No:</Text>
                <Text style={styles.value}>{data.gst_number}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.label}>Email:</Text>
                <Text style={styles.value}>
                  {data.email ? data.email : "NA"}
                </Text>
              </View>
            </View>
          </View>

          {/* Product & gst information */}
          <View style={styles.headerrow4}>
            <Text>Product Details:</Text>
          </View>

          <View style={styles.pricetableheader}>
            <View style={styles.tablecolumn1}>
              <Text>Line #</Text>
            </View>
            <View style={styles.tablecolumn5}>
              <Text>Product Code</Text>
            </View>
            <View style={styles.tablecolumn4}>
              <Text>Quantity</Text>
            </View>
            <View style={styles.tablecolumn4}>
              <Text>UOM</Text>
            </View>
            <View style={styles.tablecolumn4}>
              <Text>Rate</Text>
            </View>
            <View style={styles.tablecolumn4}>
              <Text>Discout %</Text>
            </View>
            <View style={styles.tablecolumn5}>
              <Text>Discounted Price</Text>
            </View>
            <View style={styles.tablecolumn5}>
              <Text>Value</Text>
            </View>
            {/* {data.cgst_amount && (
              <View style={styles.tablecolumn5}>
                <Text>CGST</Text>
              </View>
            )}
            {data.sgst_amount && (
              <View style={styles.tablecolumn5}>
                <Text>SGST</Text>
              </View>
            )}
            {data.igst_amount && (
              <View style={styles.tablecolumn5}>
                <Text>IGST</Text>
              </View>
            )}
            {data.ugst_amount && (
              <View style={styles.tablecolumn5}>
                <Text>UGST</Text>
              </View>
            )} */}
            {/* <View style={styles.tablecolumn5}>
              <Text>Total</Text>
            </View> */}
          </View>
          {data.quotation_line_items.map((item, i) => {
            return (
              <View key={i} style={styles.pricetablerows}>
                <View style={styles.tablecolumn1}>
                  <Text>{i + 1}</Text>
                </View>
                <View style={styles.tablecolumn5}>
                  <Text>{item.product_code}</Text>
                </View>
                <View style={styles.tablecolumn4}>
                  <Text>{item.quantity}</Text>
                </View>
                <View style={styles.tablecolumn4}>
                  <Text>{item.unit}</Text>
                </View>
                <View style={styles.tablecolumn4}>
                  <Text>
                    {(
                      item.amount /
                      (1 - item.discount / 100) /
                      item.quantity
                    ).toFixed(0)}
                  </Text>
                </View>
                <View style={styles.tablecolumn4}>
                  <Text>{item.discount}</Text>
                </View>
                <View style={styles.tablecolumn5}>
                  <Text>{Math.round(item.amount / item.quantity)}</Text>
                </View>
                <View style={styles.tablecolumn5}>
                  <Text>{item.amount}</Text>
                </View>
                {/* {data.cgst_amount && (
                  <View style={styles.tablecolumn5}>
                    <Text>{Math.round(item.gst_amount / 2)}</Text>
                  </View>
                )}
                {data.sgst_amount && (
                  <View style={styles.tablecolumn5}>
                    <Text>{Math.round(item.gst_amount / 2)}</Text>
                  </View>
                )}
                {data.igst_amount && (
                  <View style={styles.tablecolumn5}>
                    <Text>{item.gst_amount}</Text>
                  </View>
                )}
                {data.ugst_amount && (
                  <View style={styles.tablecolumn5}>
                    <Text>{item.gst_amount}</Text>
                  </View>
                )} */}

                {/* <View style={styles.tablecolumn5}>
                  <Text>{Number(item.amount) + Number(item.gst_amount)}</Text>
                </View> */}
              </View>
            );
          })}

          {/* Payment Box */}

          <View style={styles.paymentBox}>
            <View style={styles.main_row}>

            <View style={styles.payment_row}>
              <Text style={styles.payment_label}>Amount Before Tax:</Text>
              <Text style={styles.payment_value}>₹{data.total_amount.toFixed(2)}</Text>
            </View>
            <View style={styles.payment_row}>
              <Text style={styles.payment_label}>Tax:</Text>
              <Text style={styles.payment_value}>₹{(data.ugst_amount+data.cgst_amount+data.sgst_amount+data.igst_amount).toFixed(2)}</Text>
            </View>
            <View style={styles.payment_row}>
              <Text style={styles.payment_label}>Total:</Text>
              <Text style={styles.payment_value}>₹{(data.total_amount+data.ugst_amount+data.cgst_amount+data.sgst_amount+data.igst_amount).toFixed(2)}</Text>
            </View>
            </View>

          </View>
          {/* Payment Terms */}

          <View style={[styles.headerrow4, { marginTop: "10px" }]}>
            <Text>Payment Terms:</Text>
          </View>
          <View style={styles.headerbox3}>
            <View style={styles.row}>
              <Text style={styles.label}>Advance:</Text>
              <Text style={styles.value}>{"25 % Against Proforma"}</Text>
            </View>
            <View style={styles.row}>
              <Text style={styles.label}>Credit Terms:</Text>
              <Text style={styles.value}>
                {"45 Days from the Date of Invoice"}
              </Text>
            </View>
          </View>
          <View style={[styles.row, { marginLeft: "5px" }]}>
            <Text style={styles.label}>Terms & Condition:</Text>
          </View>
          <View style={[styles.row, { marginLeft: "50px" }]}>
            <Text style={[styles.label, { fontWeight: "normal" }]}>
              1 {"  "} Work will resume after advance payment.
            </Text>
          </View>
          <View style={[styles.row, { marginLeft: "50px" }]}>
            <Text style={[styles.label, { fontWeight: "normal" }]}>
              2 Remaining payment should be done before 30 days.
            </Text>
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
      <Page size="A4" style={styles.page}>
        {data.quotation_line_items.map((ele) => {
          return (
            <View key={ele.uuid}>
              <View style={styles.headerrow4}>
                <Text>Product Code: {ele.product_code}</Text>
              </View>
              {/*Tool Image */}
              <View style={[styles.tool_img, { marginTop: "10px" }]}>
                <Image
                  style={styles.image}
                  source={`${process.env.REACT_APP_IMAGE_URL}${ele.product_image}`}
                  // source={`https://make-my-tools-staging.s3.ap-south-1.amazonaws.com/product/1727616452441.png`}
                />
              </View>
              {/* Common Attributes Information  */}
              <View style={styles.headerrow4}>
                <Text>Common Attributes</Text>
              </View>
              <View style={styles.headerrow3}>
                <View style={styles.headerbox3}>
                  {ele.common_attributes &&
                    Array.isArray(ele.common_attributes) &&
                    ele.common_attributes.length > 0 &&
                    ele.common_attributes.map((item, ind) => {
                      return (
                        <View>
                          {ind <=
                            split_number(ele.common_attributes.length) && (
                            <>
                              <View style={styles.row}>
                                <Text
                                  style={styles.label}
                                >{`${item.name}:`}</Text>
                                <Text style={styles.value}>{item.value}</Text>
                              </View>
                              {/* {console.log(item.name)} */}
                              {item.name == "Workpiece Material" &&
                                item.iso_classification && (
                                  <View style={styles.row}>
                                    <Text
                                      style={styles.label}
                                    >{`ISO Classification:`}</Text>
                                    <Text style={styles.value}>
                                      {item.iso_classification}
                                    </Text>
                                  </View>
                                )}
                            </>
                          )}
                        </View>
                      );
                    })}
                </View>
                <View style={styles.headerbox3}>
                  {ele.common_attributes &&
                    Array.isArray(ele.common_attributes) &&
                    ele.common_attributes.length > 0 &&
                    ele.common_attributes.map((item, ind) => {
                      return (
                        <View>
                          {ind >=
                            split_number(ele.common_attributes.length) + 1 && (
                            <>
                              <View style={styles.row}>
                                <Text
                                  style={styles.label}
                                >{`${item.name}:`}</Text>
                                <Text style={styles.value}>{item.value}</Text>
                              </View>
                              {item.name == "Workpiece Material" &&
                                item.iso_classification && (
                                  <View style={styles.row}>
                                    <Text
                                      style={styles.label}
                                    >{`ISO Classification:`}</Text>
                                    <Text style={styles.value}>
                                      {item.iso_classification}
                                    </Text>
                                  </View>
                                )}
                            </>
                          )}
                        </View>
                      );
                    })}
                </View>
              </View>
            </View>
          );
        })}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );

  return (
    <React.Fragment>
      <div className="px-10 py-2 h-full overflow-y-auto pb-[10%]">
        <ToastContainer />
        <div className="bg-grey flex item-center justify-between">
          <div>
            <div className="p-2 flex item-center">
              <button
                onClick={() => {
                  navigate("/quotation");
                }}
              >
                <ArrowLeft color="#807e7ed7" />
              </button>

              <p className="mb-0 ms-3" style={{ fontSize: "24px" }}>
                Quotation PDF
              </p>
            </div>
          </div>

          <div className=" p-2">
            <button
              className="main-color  w-full  p-2  text-white  cursor-pointer rounded"
              style={styles.downloadButton}
              onClick={handleDownload}
              disabled={!isPdfLoaded}
            >
              Download PDF
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="createNc container-fluid">
            <PDFViewer style={styles.viewer}>
              <SupplierQuotationPDF data={data} />
            </PDFViewer>
            <a ref={downloadLinkRef} style={{ display: "none" }} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
